import { TeamsView } from '@/domains/teams/components/TeamsView';
import { useCreateTeam, useTeams } from '@/domains/teams/hooks/useTeams';
import { useUsers, userListItemToView } from '@/domains/users';
import { useMemo } from 'react';
import { useNavigate } from 'react-router';

export function TeamsPage() {
  const navigate = useNavigate();
  const { data: teams = [], isLoading, isError } = useTeams();
  const createTeam = useCreateTeam();
  const { data: usersData } = useUsers({ status: 'active', limit: '1000' });

  const allUsers = useMemo(() => usersData?.users?.map(userListItemToView) ?? [], [usersData]);

  return (
    <TeamsView
      teams={teams}
      isLoading={isLoading}
      isError={isError}
      allUsers={allUsers}
      onTeamClick={(teamId) => navigate(`/teams/${teamId}`)}
      onCreateTeam={async (name, description, maxCapacity, memberIds, teamLeadId) => {
        await createTeam.mutateAsync({
          name,
          ...(description && { description }),
          ...(maxCapacity !== null && { maxCapacity }),
          ...(memberIds.length > 0 && { memberIds }),
          ...(teamLeadId !== null && { teamLeadId }),
        });
      }}
    />
  );
}
